import Alpine from 'alpinejs'
Alpine.directive('log', (el: HTMLElement, { expression }: { expression: string }, { evaluateLater, effect }: { evaluateLater: (expression: string) => (callback: (value: any) => void) => void, effect: (callback: () => void) => void }) => {
    let getThingToLog = evaluateLater(expression)
    effect(() => {
        getThingToLog((thingToLog: any) => {
            console.log(thingToLog)
        })
    })
})
